import { useToast } from '@workramp/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { APP_CONSTANTS } from '~/common/explicit-exports';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_ASSET_DETAILS_KEY } from '../constants';
import { CMS_ASSET_DASHBOARD_VERIFICATION_QUERY_KEY } from './getDashboardVerification';

const verifyAsset = async (assetId: string): Promise<Response> => FetchPromise.post(`cms/assets/${assetId}/verify`);

export const useVerifyAsset = (assetId: string) => {
  const queryClient = useQueryClient();
  const { open: openToast } = useToast();

  return useMutation(verifyAsset, {
    onSuccess: async () => {
      await queryClient.invalidateQueries([CMS_ASSET_DETAILS_KEY, APP_CONSTANTS.CMS_ASSET_TYPES.FILE, assetId]);
      await queryClient.invalidateQueries([CMS_ASSET_DETAILS_KEY, APP_CONSTANTS.CMS_ASSET_TYPES.LINK, assetId]);
      await queryClient.invalidateQueries([CMS_ASSET_DASHBOARD_VERIFICATION_QUERY_KEY]);
    },
    onError: (err: Error) => {
      openToast({ children: err.message });
    },
  });
};
